import type { UserBody } from '~/types';
import { BaseModel } from '~/models/base-model';

export class BodiesModel extends BaseModel<UserBody> {
    isSelf = false;
    isArchived = false;
    name = '';
    email = null;
    birthdate = '';
    age = null;
    height = 0;
    heightIn = null;
    weight = 0;
    weightLb = null;
    heightFmt = '';
    heightMetricFmt = '';
    weightFmt = '';
    weightMetricFmt = '';
    gender = null;
    ethnicity = null;
    maleBodyType1 = null;
    braSize = null;
    created = null;
    updated = null;
}
